/**
 * Timeout wrapper for async operations (e.g. Supabase) to avoid "zombie connection"
 * when the tab was sleeping and the client never receives an error.
 */

export const DEFAULT_FETCH_TIMEOUT_MS = 12_000;

export const TIMEOUT_MESSAGE =
  "Zbyt długi czas oczekiwania. Sprawdź połączenie lub odśwież stronę.";

/**
 * Wraps a promise with a timeout. If the promise does not settle within `ms`,
 * rejects with a user-friendly error so the UI can show a message and retry.
 */
export function withTimeout<T>(
  promise: PromiseLike<T>,
  ms: number = DEFAULT_FETCH_TIMEOUT_MS
): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error(TIMEOUT_MESSAGE));
    }, ms);
    Promise.resolve(promise).then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (err) => {
        clearTimeout(timer);
        reject(err);
      }
    );
  });
}

export function isTimeoutError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  if (error.message === TIMEOUT_MESSAGE) return true;
  return error.name === "AbortError" || error.name === "TimeoutError";
}
